// src/app/auth.ts
import { adminFetch } from "../services/adminFetch";

export type AdminMeResponse = {
    ok: boolean;
    admin?: { id: number; email: string };
    businesses?: { id: number; name: string; slug: string; role: string }[];
    active_business_id?: number | null;
};

export async function fetchAdminMe(): Promise<AdminMeResponse> {
    const res = await adminFetch("/api/admin/auth/me");
    if (res.status === 401) throw new Error("UNAUTHORIZED");
    const data = (await res.json()) as AdminMeResponse;
    return data;
}

export async function selectBusiness(business_id: number): Promise<void> {
    const res = await adminFetch("/api/admin/auth/select_business", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ business_id }),
    });

    if (res.status === 401) throw new Error("UNAUTHORIZED");
    if (!res.ok) {
        let msg = "REQUEST_FAILED";
        try {
            const j = await res.json();
            msg = j?.error || msg;
        } catch { }
        throw new Error(msg);
    }
}
